export interface ComicChapter {
  id: string;
  title: string;
  chapterNumber: number;
  updateDate: string;
  imageCount: number;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  rating: number;
  description: string;
  tags: string[];
  status: string;
  updateTime: string;
  totalChapters: number;
  views: number;
  favorites: number;
  isHot: boolean;
  isNew: boolean;
  isRecommended: boolean;
  chapters: ComicChapter[];
}

export interface ComicCategory {
  name: string;
  slug: string;
  description: string;
  comicCount: number;
  coverComicId: string;
}

export const categories: ComicCategory[] = [
  { name: '浪漫爱情', slug: 'romance', description: '甜蜜心动的爱情故事，从校园到都市，每一段都让人心动不已', comicCount: 1280, coverComicId: 'comic-1' },
  { name: '奇幻冒险', slug: 'fantasy', description: '穿越异世界、魔法与剑、神秘的冒险旅程即将开启', comicCount: 956, coverComicId: 'comic-4' },
  { name: '动作热血', slug: 'action', description: '拳拳到肉的格斗场面，热血沸腾的战斗剧情', comicCount: 743, coverComicId: 'comic-7' },
  { name: '悬疑推理', slug: 'mystery', description: '扣人心弦的悬疑故事，每一步都暗藏玄机', comicCount: 512, coverComicId: 'comic-10' },
  { name: '都市生活', slug: 'urban', description: '现代都市中的百态人生，职场、友情与成长', comicCount: 867, coverComicId: 'comic-13' },
  { name: '搞笑日常', slug: 'comedy', description: '轻松愉快的搞笑漫画，让你每天都开怀大笑', comicCount: 634, coverComicId: 'comic-16' },
  { name: 'BL/耽美', slug: 'bl', description: '细腻动人的情感描绘，唯美至极的画面表现', comicCount: 1123, coverComicId: 'comic-2' },
  { name: '恐怖惊悚', slug: 'horror', description: '令人毛骨悚然的恐怖故事，挑战你的胆量极限', comicCount: 389, coverComicId: 'comic-19' },
  { name: '科幻未来', slug: 'scifi', description: '未来世界、人工智能、星际旅行，无限想象空间', comicCount: 421, coverComicId: 'comic-22' },
  { name: '历史古风', slug: 'historical', description: '穿越时空回到古代，感受历史长河中的爱恨情仇', comicCount: 567, coverComicId: 'comic-25' },
];

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '总裁的契约新娘',
    author: '林小染',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20art%2C%20elegant%20couple%20in%20formal%20attire%2C%20soft%20warm%20lighting%2C%20clean%20minimal%20background%20with%20subtle%20floral%20elements%2C%20modern%20romance%20illustration%20style%2C%20delicate%20linework%2C%20pastel%20color%20palette%2C%20editorial%20quality%2C%20sophisticated%20and%20romantic%20atmosphere&width=800&height=1100&seq=comic-cover-01&orientation=portrait',
    category: '浪漫爱情',
    categorySlug: 'romance',
    rating: 4.8,
    description: '因家族契约被迫嫁给冷酷总裁的她，本以为只是一场交易婚姻，却在朝夕相处中渐渐发现他深藏的温柔。当真相揭开，这场契约婚姻究竟何去何从？',
    tags: ['契约婚姻', '总裁', '先婚后爱', '甜宠'],
    status: '连载中',
    updateTime: '2026-07-08',
    totalChapters: 86,
    views: 2580000,
    favorites: 326000,
    isHot: true,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: 'ch-1-1', title: '第1话 命运的相遇', chapterNumber: 1, updateDate: '2025-01-15', imageCount: 42 },
      { id: 'ch-1-2', title: '第2话 契约签订', chapterNumber: 2, updateDate: '2025-01-22', imageCount: 38 },
      { id: 'ch-1-3', title: '第3话 新婚之夜', chapterNumber: 3, updateDate: '2025-01-29', imageCount: 45 },
      { id: 'ch-1-85', title: '第85话 最后的抉择', chapterNumber: 85, updateDate: '2026-07-01', imageCount: 40 },
      { id: 'ch-1-86', title: '第86话 永不分离', chapterNumber: 86, updateDate: '2026-07-08', imageCount: 44 },
    ],
  },
  {
    id: 'comic-2',
    title: '星河之恋',
    author: '苏暖暖',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20BL%20romance%20cover%2C%20two%20handsome%20men%20facing%20each%20other%2C%20starry%20night%20background%2C%20soft%20dreamy%20lighting%2C%20elegant%20illustration%20style%2C%20subtle%20romantic%20atmosphere%2C%20delicate%20lineart%2C%20pastel%20blue%20and%20pink%20accents%2C%20clean%20composition&width=800&height=1100&seq=comic-cover-02&orientation=portrait',
    category: 'BL/耽美',
    categorySlug: 'bl',
    rating: 4.9,
    description: '在星光闪烁的夜晚，两个命运交错的灵魂相遇了。一个是天才画家，一个是音乐神童，他们在艺术的世界里找到了彼此。',
    tags: ['艺术', '音乐', '灵魂伴侣', '治愈'],
    status: '连载中',
    updateTime: '2026-07-07',
    totalChapters: 64,
    views: 1890000,
    favorites: 412000,
    isHot: true,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: 'ch-2-1', title: '第1话 星光下的邂逅', chapterNumber: 1, updateDate: '2025-04-10', imageCount: 36 },
      { id: 'ch-2-2', title: '第2话 画布上的音符', chapterNumber: 2, updateDate: '2025-04-17', imageCount: 40 },
      { id: 'ch-2-63', title: '第63话 最后的乐章', chapterNumber: 63, updateDate: '2026-06-30', imageCount: 42 },
      { id: 'ch-2-64', title: '第64话 星河永恒', chapterNumber: 64, updateDate: '2026-07-07', imageCount: 38 },
    ],
  },
  {
    id: 'comic-3',
    title: '学霸的秘密',
    author: '一只锦鲤',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20romance%20cover%2C%20high%20school%20students%20in%20uniform%2C%20cherry%20blossom%20background%2C%20warm%20spring%20lighting%2C%20sweet%20youthful%20atmosphere%2C%20clean%20illustration%20style%2C%20soft%20color%20palette%2C%20romantic%20young%20love%20theme&width=800&height=1100&seq=comic-cover-03&orientation=portrait',
    category: '浪漫爱情',
    categorySlug: 'romance',
    rating: 4.7,
    description: '全校第一的学霸居然有秘密身份？白天是冷面学霸，晚上是网络人气漫画作者。当这个秘密被班上的学渣发现后，两个人的世界彻底改变了。',
    tags: ['校园', '学霸', '秘密身份', '甜宠'],
    status: '已完结',
    updateTime: '2026-06-20',
    totalChapters: 120,
    views: 3210000,
    favorites: 289000,
    isHot: false,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: 'ch-3-1', title: '第1话 全校第一的秘密', chapterNumber: 1, updateDate: '2024-08-01', imageCount: 35 },
      { id: 'ch-3-120', title: '第120话 属于我们的未来', chapterNumber: 120, updateDate: '2026-06-20', imageCount: 50 },
    ],
  },
  {
    id: 'comic-4',
    title: '异世界归来的勇者',
    author: '极光工作室',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20action%20cover%2C%20warrior%20with%20sword%20in%20epic%20pose%2C%20magical%20energy%20effects%2C%20dark%20dramatic%20background%20with%20ruins%2C%20dynamic%20composition%2C%20adventure%20illustration%20style%2C%20warm%20golden%20accent%20lighting%2C%20powerful%20atmosphere&width=800&height=1100&seq=comic-cover-04&orientation=portrait',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    rating: 4.6,
    description: '在异世界奋战十年的勇者终于击败魔王，却意外回到了原来的世界。然而和平的日常并没有持续多久，异世界的威胁再次降临。',
    tags: ['勇者', '异世界', '战斗', '魔法'],
    status: '连载中',
    updateTime: '2026-07-08',
    totalChapters: 95,
    views: 4120000,
    favorites: 567000,
    isHot: true,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: 'ch-4-1', title: '第1话 归来的勇者', chapterNumber: 1, updateDate: '2025-02-01', imageCount: 44 },
      { id: 'ch-4-95', title: '第95话 新的敌人', chapterNumber: 95, updateDate: '2026-07-08', imageCount: 48 },
    ],
  },
  {
    id: 'comic-5',
    title: '深夜咖啡厅',
    author: '墨鱼丸',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20cover%2C%20cozy%20cafe%20interior%20at%20night%2C%20warm%20yellow%20lighting%2C%20character%20serving%20coffee%2C%20quiet%20atmospheric%20scene%2C%20soft%20illustration%20style%2C%20comforting%20mood%2C%20clean%20composition%2C%20urban%20night%20aesthetic&width=800&height=1100&seq=comic-cover-05&orientation=portrait',
    category: '都市生活',
    categorySlug: 'urban',
    rating: 4.5,
    description: '在城市的某个角落，有一家只在深夜营业的咖啡厅。来这里的人有着各自的故事，而咖啡厅的主人倾听每一个灵魂。',
    tags: ['治愈', '咖啡厅', '深夜', '人生故事'],
    status: '连载中',
    updateTime: '2026-07-06',
    totalChapters: 52,
    views: 987000,
    favorites: 156000,
    isHot: false,
    isNew: false,
    isRecommended: false,
    chapters: [
      { id: 'ch-5-1', title: '第1话 深夜来客', chapterNumber: 1, updateDate: '2026-01-10', imageCount: 32 },
      { id: 'ch-5-52', title: '第52话 第52位客人', chapterNumber: 52, updateDate: '2026-07-06', imageCount: 38 },
    ],
  },
  {
    id: 'comic-6',
    title: '你的名字在我心上',
    author: '七秒记忆',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20emotional%20romance%20cover%2C%20couple%20standing%20in%20rain%20with%20umbrella%2C%20melancholic%20atmosphere%2C%20soft%20blueish%20grey%20tones%2C%20delicate%20watercolor%20illustration%20style%2C%20poetic%20composition%2C%20gentle%20rain%20effects%2C%20romantic%20drama%20mood&width=800&height=1100&seq=comic-cover-06&orientation=portrait',
    category: '浪漫爱情',
    categorySlug: 'romance',
    rating: 4.9,
    description: '一场车祸让她失去了所有记忆，唯有心口那个名字的刺痛感挥之不去。当她终于找到名字的主人，却发现两人之间有着无法跨越的鸿沟。',
    tags: ['失忆', '虐恋', '破镜重圆', '催泪'],
    status: '已完结',
    updateTime: '2026-05-15',
    totalChapters: 78,
    views: 5670000,
    favorites: 892000,
    isHot: false,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: 'ch-6-1', title: '第1话 醒来之后', chapterNumber: 1, updateDate: '2025-06-01', imageCount: 40 },
      { id: 'ch-6-78', title: '第78话 再也不分开', chapterNumber: 78, updateDate: '2026-05-15', imageCount: 46 },
    ],
  },
  {
    id: 'comic-7',
    title: '暗影猎人',
    author: '黑羽工作室',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20thriller%20cover%2C%20masked%20hunter%20in%20dark%20alley%2C%20dramatic%20chiaroscuro%20lighting%2C%20noir%20atmosphere%2C%20dynamic%20fighting%20pose%2C%20urban%20night%20setting%2C%20intense%20mood%2C%20stylish%20illustration&width=800&height=1100&seq=comic-cover-07&orientation=portrait',
    category: '动作热血',
    categorySlug: 'action',
    rating: 4.7,
    description: '白天是普通上班族，夜晚化身为专门猎杀网络罪犯的暗影猎人。当他的双重身份即将暴露，一场生死较量就此展开。',
    tags: ['动作', '悬疑', '双重身份', '复仇'],
    status: '连载中',
    updateTime: '2026-07-08',
    totalChapters: 71,
    views: 2340000,
    favorites: 345000,
    isHot: true,
    isNew: false,
    isRecommended: false,
    chapters: [
      { id: 'ch-7-1', title: '第1话 面具之下', chapterNumber: 1, updateDate: '2025-09-01', imageCount: 41 },
      { id: 'ch-7-71', title: '第71话 终局之战', chapterNumber: 71, updateDate: '2026-07-08', imageCount: 52 },
    ],
  },
  {
    id: 'comic-8',
    title: '社内相亲',
    author: '爆米花',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20office%20romance%20comedy%20cover%2C%20business%20couple%20in%20office%20setting%2C%20bright%20cheerful%20lighting%2C%20playful%20romantic%20atmosphere%2C%20modern%20illustration%20style%2C%20clean%20colorful%20palette%2C%20fun%20energetic%20mood&width=800&height=1100&seq=comic-cover-08&orientation=portrait',
    category: '都市生活',
    categorySlug: 'urban',
    rating: 4.6,
    description: '被家里逼着去相亲，结果对面坐着的是公司新来的CEO！更离谱的是，他居然提出了一个让人无法拒绝的提议……',
    tags: ['办公室', '相亲', '喜剧', '甜宠'],
    status: '连载中',
    updateTime: '2026-07-07',
    totalChapters: 58,
    views: 1890000,
    favorites: 278000,
    isHot: false,
    isNew: false,
    isRecommended: false,
    chapters: [
      { id: 'ch-8-1', title: '第1话 相亲对象是CEO', chapterNumber: 1, updateDate: '2025-12-01', imageCount: 37 },
      { id: 'ch-8-58', title: '第58话 公开恋情', chapterNumber: 58, updateDate: '2026-07-07', imageCount: 39 },
    ],
  },
  {
    id: 'comic-9',
    title: '重生之影后归来',
    author: '星光璀璨',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20revenge%20drama%20cover%2C%20glamorous%20actress%20on%20red%20carpet%2C%20dramatic%20spotlight%20lighting%2C%20luxurious%20golden%20and%20red%20tones%2C%20elegant%20illustration%20style%2C%20powerful%20female%20lead%20presence%2C%20showbiz%20atmosphere&width=800&height=1100&seq=comic-cover-09&orientation=portrait',
    category: '都市生活',
    categorySlug: 'urban',
    rating: 4.8,
    description: '前世被最信任的人背叛至死，重生回到出道前夕。这一次，她要让所有背叛她的人付出代价，重新登上娱乐圈的巅峰。',
    tags: ['重生', '娱乐圈', '复仇', '大女主'],
    status: '连载中',
    updateTime: '2026-07-08',
    totalChapters: 103,
    views: 4780000,
    favorites: 623000,
    isHot: true,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: 'ch-9-1', title: '第1话 浴火重生', chapterNumber: 1, updateDate: '2025-03-15', imageCount: 43 },
      { id: 'ch-9-103', title: '第103话 加冕为王', chapterNumber: 103, updateDate: '2026-07-08', imageCount: 47 },
    ],
  },
  {
    id: 'comic-10',
    title: '密室逃脱',
    author: '暗夜行者',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20thriller%20cover%2C%20characters%20trapped%20in%20dark%20room%2C%20suspenseful%20atmosphere%2C%20dim%20emergency%20lighting%2C%20psychological%20horror%20elements%2C%20tense%20illustration%20style%2C%20claustrophobic%20composition%2C%20creepy%20mood&width=800&height=1100&seq=comic-cover-10&orientation=portrait',
    category: '悬疑推理',
    categorySlug: 'mystery',
    rating: 4.5,
    description: '六个陌生人被困在一栋神秘建筑中，每个房间都藏着一个致命的谜题。他们必须合作逃出生天，但每个人似乎都隐藏着不可告人的秘密。',
    tags: ['密室', '解谜', '悬疑', '生存游戏'],
    status: '连载中',
    updateTime: '2026-07-05',
    totalChapters: 44,
    views: 1560000,
    favorites: 198000,
    isHot: false,
    isNew: false,
    isRecommended: false,
    chapters: [
      { id: 'ch-10-1', title: '第1话 醒来的房间', chapterNumber: 1, updateDate: '2026-02-01', imageCount: 38 },
      { id: 'ch-10-44', title: '第44话 真相浮现', chapterNumber: 44, updateDate: '2026-07-05', imageCount: 42 },
    ],
  },
  {
    id: 'comic-11',
    title: '猫的报恩',
    author: '橘猫饲养员',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20romance%20cover%2C%20girl%20with%20magical%20cat%20companion%2C%20whimsical%20fairy%20tale%20atmosphere%2C%20soft%20golden%20sunlight%2C%20cozy%20illustration%20style%2C%20warm%20pastel%20colors%2C%20dreamy%20mood%2C%20charming%20composition&width=800&height=1100&seq=comic-cover-11&orientation=portrait',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    rating: 4.9,
    description: '救助了一只受伤的小猫后，她的生活发生了奇妙的变化。原来这只猫是来自猫之国的王子，为了报恩，他决定帮助她实现所有愿望。',
    tags: ['猫', '奇幻', '治愈', '甜宠'],
    status: '已完结',
    updateTime: '2026-04-30',
    totalChapters: 66,
    views: 2120000,
    favorites: 456000,
    isHot: false,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: 'ch-11-1', title: '第1话 雨中的小猫', chapterNumber: 1, updateDate: '2025-08-01', imageCount: 34 },
      { id: 'ch-11-66', title: '第66话 永远的约定', chapterNumber: 66, updateDate: '2026-04-30', imageCount: 45 },
    ],
  },
  {
    id: 'comic-12',
    title: '剑与玫瑰',
    author: '红莲工作室',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20romance%20cover%2C%20knight%20and%20lady%20in%20medieval%20setting%2C%20rose%20garden%20background%2C%20romantic%20soft%20lighting%2C%20elegant%20illustration%20style%2C%20classic%20romance%20atmosphere%2C%20detailed%20costume%20design&width=800&height=1100&seq=comic-cover-12&orientation=portrait',
    category: '历史古风',
    categorySlug: 'historical',
    rating: 4.7,
    description: '她是王国最出色的女骑士，他是敌国的王子。在战火纷飞的年代，一把剑与一朵玫瑰，交织出一段跨越国界的禁忌之恋。',
    tags: ['骑士', '宫廷', '禁忌之恋', '战争'],
    status: '已完结',
    updateTime: '2026-03-20',
    totalChapters: 90,
    views: 1670000,
    favorites: 234000,
    isHot: false,
    isNew: false,
    isRecommended: false,
    chapters: [
      { id: 'ch-12-1', title: '第1话 战场上的相遇', chapterNumber: 1, updateDate: '2025-04-01', imageCount: 41 },
      { id: 'ch-12-90', title: '第90话 和平之花', chapterNumber: 90, updateDate: '2026-03-20', imageCount: 48 },
    ],
  },
  {
    id: 'comic-13',
    title: '财阀家的小儿子',
    author: '钱多多',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20business%20drama%20cover%2C%20young%20man%20in%20luxury%20office%2C%20corporate%20power%20struggle%20theme%2C%20sophisticated%20modern%20setting%2C%20dramatic%20lighting%2C%20stylish%20illustration%2C%20wealthy%20aesthetic%2C%20clean%20composition&width=800&height=1100&seq=comic-cover-13&orientation=portrait',
    category: '都市生活',
    categorySlug: 'urban',
    rating: 4.8,
    description: '重生成为韩国最大财阀家的小儿子，本以为可以躺赢人生，却发现这个家族内部的权力斗争远比想象的残酷。',
    tags: ['重生', '财阀', '商战', '家族'],
    status: '连载中',
    updateTime: '2026-07-08',
    totalChapters: 112,
    views: 6230000,
    favorites: 781000,
    isHot: true,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: 'ch-13-1', title: '第1话 重回1997', chapterNumber: 1, updateDate: '2025-01-01', imageCount: 45 },
      { id: 'ch-13-112', title: '第112话 继承之战', chapterNumber: 112, updateDate: '2026-07-08', imageCount: 50 },
    ],
  },
  {
    id: 'comic-14',
    title: '搞笑一家人',
    author: '开心果',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20family%20comedy%20cover%2C%20chaotic%20family%20gathering%2C%20bright%20colorful%20illustration%2C%20funny%20expressions%2C%20warm%20home%20setting%2C%20humorous%20atmosphere%2C%20cartoony%20style%2C%20energetic%20composition&width=800&height=1100&seq=comic-cover-14&orientation=portrait',
    category: '搞笑日常',
    categorySlug: 'comedy',
    rating: 4.6,
    description: '一家五口的爆笑日常！严厉的爸爸、唠叨的妈妈、中二的哥哥、追星族姐姐，还有一只会说话的猫。每天都是鸡飞狗跳的新冒险。',
    tags: ['家庭', '搞笑', '日常', '温馨'],
    status: '连载中',
    updateTime: '2026-07-06',
    totalChapters: 156,
    views: 3450000,
    favorites: 456000,
    isHot: false,
    isNew: false,
    isRecommended: false,
    chapters: [
      { id: 'ch-14-1', title: '第1话 一家人的早晨', chapterNumber: 1, updateDate: '2024-06-01', imageCount: 28 },
      { id: 'ch-14-156', title: '第156话 暑假旅行', chapterNumber: 156, updateDate: '2026-07-06', imageCount: 32 },
    ],
  },
  {
    id: 'comic-15',
    title: '恶女的品格',
    author: '黑色曼陀罗',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20villainess%20drama%20cover%2C%20elegant%20woman%20in%20dark%20dress%2C%20gothic%20castle%20background%2C%20dramatic%20moonlight%2C%20dark%20romantic%20atmosphere%2C%20intricate%20illustration%20style%2C%20powerful%20female%20character%2C%20victorian%20aesthetic&width=800&height=1100&seq=comic-cover-15&orientation=portrait',
    category: '历史古风',
    categorySlug: 'historical',
    rating: 4.7,
    description: '被诬陷为恶女处刑后，她重生回到悲剧发生之前。这一次，她决定做一个真正的"恶女"，让所有伤害过她的人付出代价。',
    tags: ['恶女', '重生', '复仇', '宫廷'],
    status: '连载中',
    updateTime: '2026-07-08',
    totalChapters: 88,
    views: 3890000,
    favorites: 534000,
    isHot: true,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: 'ch-15-1', title: '第1话 断头台上的誓言', chapterNumber: 1, updateDate: '2025-05-01', imageCount: 46 },
      { id: 'ch-15-88', title: '第88话 女王的诞生', chapterNumber: 88, updateDate: '2026-07-08', imageCount: 51 },
    ],
  },
  {
    id: 'comic-16',
    title: '今天也很可爱',
    author: '棉花糖',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cute%20comedy%20cover%2C%20adorable%20animal%20characters%2C%20pastel%20color%20palette%2C%20kawaii%20illustration%20style%2C%20bright%20cheerful%20atmosphere%2C%20simple%20clean%20design%2C%20playful%20mood%2C%20chibi%20art%20style&width=800&height=1100&seq=comic-cover-16&orientation=portrait',
    category: '搞笑日常',
    categorySlug: 'comedy',
    rating: 4.4,
    description: '四格漫画形式的轻松日常！讲述一只自以为很帅的哈士奇和它的主人们之间的搞笑故事。每集都能让你笑到肚子疼。',
    tags: ['四格漫画', '宠物', '搞笑', '轻松'],
    status: '连载中',
    updateTime: '2026-07-07',
    totalChapters: 234,
    views: 1560000,
    favorites: 198000,
    isHot: false,
    isNew: false,
    isRecommended: false,
    chapters: [
      { id: 'ch-16-1', title: '第1话 哈士奇的日常', chapterNumber: 1, updateDate: '2024-03-01', imageCount: 12 },
      { id: 'ch-16-234', title: '第234话 新玩具', chapterNumber: 234, updateDate: '2026-07-07', imageCount: 14 },
    ],
  },
  {
    id: 'comic-17',
    title: '魔法学院特优生',
    author: '极光工作室',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20magic%20academy%20cover%2C%20students%20in%20magical%20school%20uniform%2C%20floating%20spell%20effects%2C%20grand%20castle%20background%2C%20fantasy%20illustration%20style%2C%20mystical%20atmosphere%2C%20warm%20golden%20light%2C%20enchanting%20composition&width=800&height=1100&seq=comic-cover-17&orientation=portrait',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    rating: 4.5,
    description: '出身平民的她意外被顶级魔法学院录取，在这里她不仅要学习魔法，还要面对贵族同学们的刁难。然而她体内隐藏的魔法天赋，远超所有人的想象。',
    tags: ['魔法', '学院', '成长', '逆袭'],
    status: '连载中',
    updateTime: '2026-07-05',
    totalChapters: 67,
    views: 2120000,
    favorites: 289000,
    isHot: false,
    isNew: false,
    isRecommended: false,
    chapters: [
      { id: 'ch-17-1', title: '第1话 录取通知书', chapterNumber: 1, updateDate: '2025-10-01', imageCount: 39 },
      { id: 'ch-17-67', title: '第67话 觉醒', chapterNumber: 67, updateDate: '2026-07-05', imageCount: 44 },
    ],
  },
  {
    id: 'comic-18',
    title: '邻居是吸血鬼',
    author: '月下独酌',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20supernatural%20romance%20cover%2C%20vampire%20character%20in%20modern%20city%2C%20moonlit%20night%20scene%2C%20gothic%20romantic%20atmosphere%2C%20dark%20elegant%20illustration%20style%2C%20mysterious%20mood%2C%20red%20and%20black%20color%20scheme&width=800&height=1100&seq=comic-cover-18&orientation=portrait',
    category: '浪漫爱情',
    categorySlug: 'romance',
    rating: 4.6,
    description: '搬进新公寓后发现隔壁住着一个超级大帅哥，可惜他只在晚上出门。某天意外发现，他居然是一个活了几百年的吸血鬼……',
    tags: ['吸血鬼', '都市', '奇幻爱情', '甜宠'],
    status: '连载中',
    updateTime: '2026-07-07',
    totalChapters: 49,
    views: 1450000,
    favorites: 223000,
    isHot: false,
    isNew: false,
    isRecommended: false,
    chapters: [
      { id: 'ch-18-1', title: '第1话 新邻居', chapterNumber: 1, updateDate: '2026-02-15', imageCount: 36 },
      { id: 'ch-18-49', title: '第49话 永生之约', chapterNumber: 49, updateDate: '2026-07-07', imageCount: 41 },
    ],
  },
  {
    id: 'comic-19',
    title: '第十三号病房',
    author: '夜不语',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20cover%2C%20abandoned%20hospital%20corridor%2C%20eerie%20greenish%20lighting%2C%20ghostly%20figure%20in%20distance%2C%20dark%20atmospheric%20illustration%2C%20psychological%20horror%20style%2C%20creepy%20mood%2C%20scary%20composition&width=800&height=1100&seq=comic-cover-19&orientation=portrait',
    category: '恐怖惊悚',
    categorySlug: 'horror',
    rating: 4.3,
    description: '作为一名实习医生，她被分配到了一间据说不存在的病房——第十三号病房。每到午夜，病房里就会传出奇怪的声音……',
    tags: ['医院', '灵异', '恐怖', '心理'],
    status: '连载中',
    updateTime: '2026-07-04',
    totalChapters: 38,
    views: 987000,
    favorites: 134000,
    isHot: false,
    isNew: false,
    isRecommended: false,
    chapters: [
      { id: 'ch-19-1', title: '第1话 夜班', chapterNumber: 1, updateDate: '2026-03-01', imageCount: 35 },
      { id: 'ch-19-38', title: '第38话 病房的秘密', chapterNumber: 38, updateDate: '2026-07-04', imageCount: 40 },
    ],
  },
  {
    id: 'comic-20',
    title: 'AI恋人',
    author: '代码诗人',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20sci-fi%20romance%20cover%2C%20android%20character%20with%20human%2C%20futuristic%20cityscape%20background%2C%20neon%20lighting%2C%20cyberpunk%20aesthetic%2C%20emotional%20illustration%20style%2C%20technological%20romance%20theme%2C%20blue%20and%20pink%20neon%20colors&width=800&height=1100&seq=comic-cover-20&orientation=portrait',
    category: '科幻未来',
    categorySlug: 'scifi',
    rating: 4.5,
    description: '2050年，人工智能已经完美融入人类社会。她购买了一个AI伴侣机器人，却没想到这个机器人渐渐产生了真实的感情。',
    tags: ['AI', '科幻', '爱情', '未来'],
    status: '已完结',
    updateTime: '2026-06-15',
    totalChapters: 55,
    views: 1670000,
    favorites: 234000,
    isHot: false,
    isNew: false,
    isRecommended: false,
    chapters: [
      { id: 'ch-20-1', title: '第1话 开箱', chapterNumber: 1, updateDate: '2025-11-01', imageCount: 37 },
      { id: 'ch-20-55', title: '第55话 超越代码的爱', chapterNumber: 55, updateDate: '2026-06-15', imageCount: 43 },
    ],
  },
];

export const heroBanners = [
  {
    id: 'banner-1',
    comicId: 'comic-13',
    title: '财阀家的小儿子',
    subtitle: '重生1997，改写命运',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20luxury%20corporate%20drama%20banner%2C%20young%20man%20overlooking%20city%20skyline%20from%20penthouse%2C%20golden%20sunset%20lighting%2C%20dramatic%20cinematic%20composition%2C%20rich%20dark%20tones%2C%20powerful%20atmosphere%2C%20stylish%20modern%20aesthetic%2C%20clean%20minimal%20background&width=1400&height=700&seq=hero-banner-01&orientation=landscape',
    tag: '本周霸权',
  },
  {
    id: 'banner-2',
    comicId: 'comic-9',
    title: '重生之影后归来',
    subtitle: '娱乐圈复仇大女主',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20glamorous%20showbiz%20drama%20banner%2C%20actress%20on%20stage%20with%20spotlight%2C%20dramatic%20theater%20lighting%2C%20elegant%20cinematic%20composition%2C%20warm%20golden%20and%20red%20tones%2C%20powerful%20female%20presence%2C%20stylish%20modern%20aesthetic&width=1400&height=700&seq=hero-banner-02&orientation=landscape',
    tag: '热门推荐',
  },
  {
    id: 'banner-3',
    comicId: 'comic-4',
    title: '异世界归来的勇者',
    subtitle: '史诗级奇幻冒险',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20epic%20fantasy%20adventure%20banner%2C%20warrior%20standing%20on%20cliff%20overlooking%20magical%20landscape%2C%20golden%20hour%20lighting%2C%20cinematic%20wide%20composition%2C%20epic%20scale%2C%20adventure%20atmosphere%2C%20warm%20natural%20colors&width=1400&height=700&seq=hero-banner-03&orientation=landscape',
    tag: '新番推荐',
  },
];

export const hotRankings = comics
  .sort((a, b) => b.views - a.views)
  .slice(0, 10);

export const latestUpdates = comics
  .sort((a, b) => new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime())
  .slice(0, 12);

export const recommendedComics = comics.filter(c => c.isRecommended);

export function getComicsByCategory(slug: string): Comic[] {
  return comics.filter(c => c.categorySlug === slug);
}

export function getComicById(id: string): Comic | undefined {
  return comics.find(c => c.id === id);
}

export function getCategoryBySlug(slug: string): ComicCategory | undefined {
  return categories.find(c => c.slug === slug);
}

export function getRelatedComics(comicId: string, limit: number = 6): Comic[] {
  const comic = getComicById(comicId);
  if (!comic) return [];
  return comics
    .filter(c => c.id !== comicId && c.categorySlug === comic.categorySlug)
    .slice(0, limit);
}